const contactUs = {
  title: "Kontakt",
  forms: {
    student: "Ich bin Schüler/in oder Elternteil",
    teacher: "Ich bin Lehrkraft",
    other: "Sonstiges",
  },
  faq: {
    title: "FAQ",
    sections: {
      password: {
        q: "Passwort vergessen?",
        a: "Gehen Sie zu Ihrer Anmeldeseite und klicken Sie auf „Passwort vergessen?“",
      },
    },
  },
};

export default contactUs;
